/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const adminNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : '/dashboard'
    },
    {
        id   : 'participants',
        title: 'Utilizatori',
        type : 'basic',
        icon : 'heroicons_outline:user',
        link : '/participants'
    },
    {
        id   : 'sessions',
        title: 'Sesiuni',
        type : 'basic',
        icon : 'heroicons_outline:calculator',
        link : '/sessions'
    },
    {
        id   : 'sessions-feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:color-swatch',
        link : '/sessions-feedback'
    },
    {
        id   : 'exports',
        title: 'Export',
        type : 'basic',
        icon : 'heroicons_outline:download',
        link : '/exports'
    },
    {
        id   : 'tests',
        title: 'Teste',
        type : 'basic',
        icon : 'heroicons_outline:newspaper',
        link : '/tests'
    },
    {
        id   : 'answer-sheets',
        title: 'Borderouri',
        type : 'basic',
        icon : 'heroicons_outline:table',
        link : '/answer-sheets'
    },
    {
        id   : 'contestations',
        title: 'Contestatii',
        type : 'basic',
        icon : 'heroicons_outline:flag',
        link : '/contestations'
    },
    {
        id   : 'collab-protocols',
        title: 'Protocoale',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/collab-protocols'
    },
    {
        id   : 'settings',
        title: 'Setari',
        type : 'basic',
        icon : 'heroicons_outline:cog',
        link : '/settings'
    },
    {
        id   : 'emails',
        title: 'Emailuri',
        type : 'basic',
        icon : 'heroicons_outline:mail',
        link : '/emails'
    },
    {
        id   : 'media',
        title: 'Media',
        type : 'basic',
        icon : 'heroicons_outline:photograph',
        link : '/media'
    },
    {
        id   : 'site-content',
        title: 'Conținut site',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/site-content'
    },
    {
        id   : 'jobs',
        title: 'Joburi',
        type : 'basic',
        icon : 'heroicons_outline:clock',
        link : '/jobs'
    },
    {
        id   : 'task-monitor',
        title: 'Task Monitor',
        type : 'basic',
        icon : 'heroicons_outline:status-online',
        link : '/task-monitor'
    },
    {
        id   : 'cookie-consent',
        title: 'Cookie-uri',
        type : 'basic',
        icon : 'heroicons_outline:shield-check',
        link : '/cookie-consent'
    },
    {
        type : 'divider'
    },
    {
        // Children are populated at runtime by NavigationService from Settings.pastEditions.
        id      : 'istoric-etape',
        title   : 'Istoric Etape',
        type    : 'collapsable',
        icon    : 'heroicons_outline:archive',
        children: []
    }
];


export const orderOperatorNavigation: FuseNavigationItem[] = [
    {
        id   : 'participants',
        title: 'Utilizatori',
        type : 'basic',
        icon : 'heroicons_outline:user',
        link : '/participants'
    },
    {
        id   : 'sessions',
        title: 'Sesiuni',
        type : 'basic',
        icon : 'heroicons_outline:calculator',
        link : '/sessions'
    },
    {
        id   : 'tests',
        title: 'Teste',
        type : 'basic',
        icon : 'heroicons_outline:newspaper',
        link : '/tests'
    },
];
